'use strict';

angular.module('buyers')
.directive('watchlistNotification', function() {
    return {
        templateUrl : "partials/watchlist-notifications.html",
        restrict: 'E', // attribute
        scope: {
            'back': '&onBack',
            'notifications':'=',
            'property':'='
        }
    };
});